import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { PAYROLL_PROCESS_STATUS } from '@ubeya/shared-web/constants';
import { getLeafChildrenData } from 'timeSheet/utils';
import PayrollProcessAggregatorRenderer from 'timeSheet/components/CellRenderers/PayrollProcessAggregatorRenderer';
import PayrollProcessRenderer from 'timeSheet/components/CellRenderers/PayrollProcessRenderer';

const useProcessColumn = () => {
  const { t, isRtl } = useContext(ConfigContext);

  const valueGetter = useCallback((params) => {
    if (params.node?.group) {
      return null;
    }
    return params.data?.payrollProcess?.status || PAYROLL_PROCESS_STATUS.OTHER;
  }, []);

  const cellRenderer = useCallback((params) => {
    if (params.node?.group) {
      return PayrollProcessAggregatorRenderer({
        rowData: { summarized: false, subRows: getLeafChildrenData(params.node) }
      });
    }

    return PayrollProcessRenderer({
      rowData: params.data
    });
  }, []);

  return useMemo(
    () => ({
      field: 'process',
      headerName: t('columnHeaderProcessedPayroll'),
      pinned: isRtl ? 'right' : 'left',
      minWidth: 85,
      width: 85,
      sortable: false,
      suppressMovable: true,
      resizable: false,
      valueGetter,
      cellRenderer
    }),
    [t, valueGetter, cellRenderer, isRtl]
  );
};

export default useProcessColumn;
